import { API, axios, SendRequest, toastr} from '@/imports-files/pages/career/career-setting.js';


export class CareerSettingService extends SendRequest
{
    async resetCareer()
    {
         try 
         {
            const result = await axios.put( API.client.career_site.RESET_CAREER,
                                              {},
                                              this.setHeaderJSON(),
                                              this.setCrossDomainTrue(),
                                              this.setCredentialsJSON()
                                           );
            return result;
          } 
          catch (error) 
          {
            return error;
          }
    }

    async customCareerPageLink(value) {
      var url = API.client.career.UPDATE_CUSTOM_BACK_URL;
      try {
        const result = await axios.patch(
          url,
          { url: value },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON()
        );
        return result;
      } catch (error) {
        return error;
      }
    }
   
}
